import React, {useState, useEffect} from "react";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default function ConfirmModal(props) {

    let {
        modalSize='md',
        bgColor='white',
        textColor='secondary',
        btnColor='primary',
        id,
        header,
        body,
        confirmTxt,
        show } = props;

    // also in props: props.onConfirm, props.onCancelConfirm

    const [disabled, setDisabled] = useState(false);
    const [btnCta, setBtnCta] = useState(confirmTxt);

    useEffect(() => {
        if(show) {
            // reset
            setBtnCta(props.confirmTxt);
            setDisabled(false);
        }
    }, [show])

    const onConfirmation = () => {
        setDisabled(true);
        props.onConfirm();
    }

    return (
        <Modal id={`modal${id}`} show={show} onHide={() => props.onCancelConfirm()} centered={true} size={modalSize} contentClassName={`modal-filled bg-${bgColor} text-${textColor}`}>
            <Modal.Dialog className={'my-1'}>
                <Modal.Header closeButton>
                    <i className="fal fa-exclamation-circle me-1" style={{fontSize: '20px'}}/>
                    <span className={'fs-5 fw-bold'}>{header}</span>
                </Modal.Header>
                <Modal.Body>
                    {body}
                </Modal.Body>
                <Modal.Footer className={'flex-nowrap'}>
                    <Button variant={'light'} onClick={() => props.onCancelConfirm()}>Cancel</Button>
                    <Button variant={btnColor} onClick={() => { setBtnCta('Sending...'); onConfirmation()}} disabled={disabled} >{btnCta}</Button>
                </Modal.Footer>
            </Modal.Dialog>
        </Modal>
    )
}